import React from "react";
import "./tnc.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../footer/Footer";
const Tnc = () => {
  window.scrollTo(0, 0);
  return (<>
    <div className="bck">
      <Navbar />
      <div className="tnc-container">
        <p>
          These terms and conditions of use (“Terms of Use”) of the Website (as
          defined below) between Jac Pvt. Ltd. or “Yakuza e-vehcile Pvt. Ltd.“)
        </p>
        <p>&nbsp;</p>
        <p>
          Please read the terms of use carefully before using or booking the
          ride on the website or accessing any material, information or services
          by the website shall signify your acceptance of the terms of use and
          your agreement to be legally bound by the same
        </p>
        <p>&nbsp;</p>
        <h1>1.&nbsp; General</h1>
        <ul>
          <li>
            <a href="....">jain Auto Corp.com </a>is an Internet based portal
            owned and operated by Jac Pvt. Ltd., a company Address here. Use of
            the Website is offered to You conditio contained in these Terms,
            along with any amendments made by Jac Pvt. Ltd. at its sole
            discretion and posted on the access to or use of a Service;
          </li>
          <li>
            Jac Pvt. Ltd. shall not be required to notify You, whether as a
            registered user or not, of any changes made to the on the Website.
            Your use of the Website and the Services is subject to the most
            current version of the Terms of Use made available on t visit the
            home page
            <a href="....">jain Auto Corp.com </a>to view the most current Terms
            of Use. You can determine when Jac Pvt. Updated” legend above. It
            shall be Your responsibility to check these Terms of Use
            periodically for changes. Jac Pvt Terms of Use in a specified manner
            before prior to any further use of the Website and the Services is
            provided on the Website. If no suc following changes to the Terms of
            Use, will constitute Your irrevocable acceptance of those changes;
          </li>
          <li>
            By (i) using this Website or any facility or Service provided by
            this Website in any way; or <br /> (ii) merely browsing the Website,
            You these Terms of Use and the Website’s Privacy Policy available at
            the homepage.
          </li>
          <li>
            Jac Pvt. Ltd. agrees to deliver the merchandise ordered by you only
            at such locations as per the Order Confirmation any merchandize or
            Services purchased by Users for delivery in locations outside India
            shall not be entertained;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>2.&nbsp; Services</h1>
        <p>
          2.1) The Website is a platform that facilitates the online sale and
          purchase of branded merchandise and services offered by{" "}
          <strong>Jain Auto Corp</strong>
          vendors/service providers (“Services”). The purchase of products and
          services on the Website shall be governed by the Terms of Offer
        </p>
        <p>&nbsp;</p>
        <h1>3.&nbsp; Book A Ride/ Book a Slot</h1>
        <ul>
          <li>
            The Website also allows restricted access to the Services for
            unrecognised Users;
          </li>
          <li>
            You shall ensure that the Information provided by You in the
            Website’s registration form is complete, accurate and up-to-
            Services is expressly prohibited;
          </li>
          <li>
            If You provide any information that is untrue, inaccurate, not
            current or incomplete Jac Pvt. Ltd. has the right to current or
            future use of the Website (or any portion thereof) and further
            reserves it right to proceed against you as per law in case of any
            Froud.
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>4.&nbsp; Pricing Information</h1>
        <ul>
          <li>
            Jac Pvt. Ltd. strives to provide You with the best prices possible
            on products and services You call on store and welcome to see
            detailed under the Terms of Offer For Sale;
          </li>

          <li>
            Jac Pvt. Ltd. shall be under no liability whatsoever in respect of
            any loss or damage arising directly or indirectly of you/cardholder
            having exceeded the preset limit mutually agreed by Jac Pvt. Ltd.
          </li>
        </ul>
        <h1>5.&nbsp; User Obligations</h1>
        <ul>
          <li>
            Subject to compliance with the Terms of Use, Jac Pvt. Ltd. grants
            You a non-exclusive, limited privilege to access
          </li>
          <li>
            You agree to use the Services, Website and the materials provided
            there in only for purposes that are permitted by: (a) the Terms of
            practices or guidelines in the relevant jurisdictions;
          </li>
          <li>
            You agree to adhere to all limitations on dissemination, use and
            reproduction of any materials (such as the product catalogues) that
          </li>
          <li>
            You agree not to access (or attempt to access) the Website and the
            materials or Services by any means other than through the interf not
            use any deep-link, robot, spider or other automatic device, program,
            algorithm or methodology, or any similar or equivalent manual
            Website or Content (as defined below), or in any way reproduce or
            circumvent the navigational structure or presentation of the Website
            materials, documents or information through any means not
            specifically made available through the Website;
          </li>
          <li>
            You acknowledge and agree that by accessing or using the Website or
            Services, You may be exposed to content from otherwise
            objectionable. Jac Pvt. Ltd. disclaims all liabilities arising in
            relation to such offensive content in the manner prescribed under
            Section 17 herein;
          </li>

          <li>
            You agree that You are solely responsible to Jac Pvt. Ltd. and to
            any third party for any breach of consequences (including any loss
            or damage which Jac Pvt. Ltd. or its affiliates or its vendors may
            suff proceeded against in accordance with the appropriate law at
            your own risk and consequences;
          </li>
          <li>
            You agree that Jac Pvt. Ltd. may, at any time, modify or discontinue
            all or part of the Website, cha offer opportunities to some or all
            Website Users;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>7.&nbsp; Use of Materials</h1>
        <ul>
          <li>
            Except as expressly indicated to the contrary in any applicable
            Additional Terms, Jac Pvt. Ltd. hereby grants Yo One Mobility Pvt.
            Ltd.), non-transferable access to view, download and print product
            catalogues or any other materials available on the use the materials
            solely for personal, informational, and internal purposes, in
            accordance with the Terms of Use; You may not modify o Website; You
            may not distribute or sell, rent, lease, license or otherwise make
            the product catalogues or any other materials available o text,
            copyright or other proprietary notices contained in the product
            catalogues or any other materials available on the Website;
          </li>
          <li>
            The rights granted to You in the product catalogues or any other
            materials as specified above are not applicable to the design, layo
            are protected by intellectual property rights and may not be copied
            or imitated in whole or in part. The product catalogues or any other
            retransmitted unless expressly permitted by Jac Pvt. Ltd.;
          </li>
          <li>
            Any software that is available on the Website is the property of Jac
            Pvt. Ltd. or its vendors. You may not use, do otherwise expressly
            permitted by these Terms of Use or by the express written permission
            of Jac Pvt.
          </li>
          <li>
            Any purchase of the merchandise or Services from the Website will be
            strictly for personal use of the User. The User hereby expre User
            will not be sold, resold, bartered or in any way used for any
            commercial purposes or for profit. The User hereby acknowledges tha
            any third party for profit. In case of any breach of the aforesaid
            conditions You would be liable to proceeded against in accordance
            with accept the liability thereof;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>8.&nbsp; Usage Conduct</h1>
        <p>
          8.1) You shall solely be responsible for maintaining the necessary
          computer equipments and Internet connections that may be required 8.2)
          You are also under an obligation to use this Website for reasonable
          and lawful purposes only, and shall not indulge in any activity t 8.3)
          You shall use this Website, and any voucher/ coupons purchased through
          it, for personal, non-commercial use only and shall not re
        </p>
        <p>
          8.4) Jac Pvt. Ltd. shall be under no liability whatsoever in respect
          of any loss or damage arising directly or indirectly account of
          you/cardholder having exceeded the preset limit mutually agreed by Jac
          Pvt. Ltd. with our acquiring bank
        </p>
        <p>&nbsp;</p>
        <h1>9.&nbsp; Intellectual Property Rights</h1>
        <ul>
          <li>
            The Website and the processes, and their selection and arrangement,
            including but not limited to all text, graphics, user interfaces,
            computer code (collectively, the “Content”) on the Website is owned
            and controlled by Jac Pvt. Ltd. and the design, arrangement of such
            Content is protected by copyright, patent and trademark laws, and
            various other intellectual property rights;
          </li>
          <li>
            The trademarks, logos and service marks displayed on the Website
            (“Marks”) are the property of Jac Pvt. Ltd. o use the Marks without
            the prior consent of Jac Pvt. Ltd., the vendor or the third party
            that may own the Marks;
          </li>
          <li>
            Unless otherwise indicated or anything contained to the contrary or
            any proprietary material owned by a third party and so express
            property rights to and into the trademark "jain Auto Corp", and the
            Website, including, without limitation, any and all rights, title
            and inte designs, know-how, trade secrets and inventions (patent
            pending), goodwill, source code, meta tags, databases, text,
            content, graphics,
          </li>
          <li>
            Except as expressly provided herein, You acknowledge and agree that
            You shall not copy, republish, post, display, translate, transm
            without obtaining the necessary authorization from jain Auto Corp. Pvt. Ltd. or thirty party owner of such Content;
          </li>
          <li>
            In case of any breach of the aforesaid conditions You would be
            liable to proceeded against in accordance with the ap accept the
            liability thereof;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>10.&nbsp; Third Party Content</h1>
        <p>
          The Website makes available general third party information such as,
          product catalogues, lists of authorized dealers, reports on news, e
          videos, images and photographs of the products and other data from
          external sources (“Third Party Content”). Similar Third Party Con from
          Jac Pvt. Ltd.. The provision of Third Party Content is for general
          informational purposes only. You acknowled sources believed to be
          reliable. Jac Pvt. Ltd. does not provide any guarantee with respect to
          any the Third Party Con any loss suffered by You based on Your
          reliance on or use of such data;
        </p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <h1>11.&nbsp; Disclaimer Of Warranties &amp; Liability</h1>
        <p>
          You expressly understand and agree that, to the maximum extent
          permitted by applicable law:
        </p>
        <p>&nbsp;</p>
        <ul>
          <li>
            The website, services and other materials are provided by Jain Auto Corp pvt. Ltd. On an “AS IS” Basis without warranty the
            implied warranties of title, non-infringement, merchantability or
            fitness for a particular purpose. Without limiting the foregoing,
            Ele website or the services will meet your requirements or your use
            of the website or the services will be uninterrupted, timely, secure
            or er website, services or materials will be effective, accurate or
            reliable; <br />(iii) the quality of the website, services or other
            materials will meet website, services or other materials will be
            corrected. No advice or information, whether oral or written,
            obtained by you from Jac shall create any warranty not
            expressly stated in the terms of use;
          </li>
          <li>
            To the maximum extent permitted by applicable law, Will have no liability related to user content
            obscenity or other laws. Jac Pvt. Ltd. Also disclaims all liability
            with respect to the misuse, loss, modification or unauthorized.
          </li>
          <li>
            Jac Pvt. Ltd. will not be liable for any loss that you may incur as
            a consequence of unauthorized use of your ac any services or
            materials, either with or without your knowledge. Jac Pvt. Ltd. Has
            endeavored to ensure that all the Pvt. Ltd. Neither warrants nor
            makes any representations regarding the quality, accuracy or
            completeness of any data, information, pro responsible for the delay
            or inability to use the website or related functionalities, the
            provision of or failure to provide functionalities, o related
            graphics obtained through the website, or otherwise arising out of
            the use of the website, whether based on contract, tort, neglig Pvt.
            Ltd. Shall not be held responsible for non-availability of the
            website during periodic maintenance operations or any unplanned sus
            reasons or for any reason beyond Jac Pvt. Ltd.‘s control. The user
            understands and agrees that any material or data d entirely at their
            own discretion and risk and they will be solely responsible for any
            damage to their computer systems or loss of data tha Mobility Pvt.
            Ltd. Is not responsible for any typographical error leading to an
            invalid coupon. Jac Pvt. Ltd. Accepts information provided to you
            whether on behalf of itself or third parties;
          </li>
          <li>
            Jac Pvt. Ltd. Shall not be liable for any third party product or
            services. The advertisement available on E-Mail and services are for
            information purpose only;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>12.&nbsp;&nbsp; Indemnification and Limitation of Liability</h1>
        <ul>

          <li>
            Notwithstanding anything to contrary, Jac Pvt. Ltd.‘s entire
            liability to You under this Terms of Use or otherwi specific voucher
            or product or service, under which the unlikely liability arises;
          </li>
          <li>
            In no event shall Jac Pvt. Ltd., its officers, directors, employees,
            partners or suppliers be liable to You, the ven consequential or
            punitive damages whatsoever, including those resulting from loss of
            use, data or profits, whether or not foreseeable or of the
            possibility of such damages, or based on any theory of liability,
            including breach of contract or warranty, negligence or other tort
            Your use of or access to the Website, Services or materials;
          </li>
          <li>
            The limitations and exclusions in this section apply to the maximum
            extent permitted by applicable law;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>13.&nbsp;&nbsp; Violation of the Terms of Use</h1>
        <ul>

          <li>
            You agree that Jac Pvt. Ltd. may, in its sole discretion, and
            without prior notice, terminate Your a limited to): (1) requests by
            law enforcement or other government agencies; (2) a request by You
            (self-initiated account de Website or any service offered on or
            through the Website; (4) unexpected technical issues or problems; or
            (5) breach of T conditions, or policies that may be applicable to
            You from time to time;
          </li>
          <li>
            If Jac Pvt. Ltd. does take any suitable legal action against You as
            a result of Your violation of the entitled to recover from You, and
            You agree to pay, all reasonable attorneys’ fees and costs of such
            action, in addition to a These “third-party“ websites and
            advertisers may use technology to send the advertisements that
            appear on the Website di websites or advertisers automatically
            receive Your IP address. They may also use cookies, JavaScript, web
            beacons and o advertisements and to personalize advertising content.
            Jac Pvt. Ltd. does not have access to or control and advertisers may
            use, and the information practices of these third-party websites and
            advertisers are not covered by thi about their privacy practices.
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>14.&nbsp; Termination</h1>
        <ul>
          <li>
            The Terms of Use will continue to apply until terminated by either
            You or Jac Pvt. Ltd. as set forth If Y Pvt. Ltd., You may do so by
            (i) not accessing the Website; or (ii) closing Your accounts for all
            of the Services that You use, where Elec
          </li>
          <li>
            Jac Pvt. Ltd. may, at any time, with or without notice, terminate
            the Terms of Use (or portion thereof, such as a the provisions of
            the Terms of Use, the Privacy Policy or any other terms, conditions,
            or policies that may be applicable to You from ti do not intend to,
            or are unable to, comply with the same);  is required to do so by law (for example, whe The provision of
            the Services to You by Jac Pvt. Ltd. is, in Jac Pvt. Ltd.‘s opinion,
            no longer com discontinue, with or without reason, access to the
            Website, the Services (or any part thereof); or
          </li>
          <li>
            Jac Pvt. Ltd. may also terminate or suspend all or a portion of Your
            account or access to the Services with or w applicable to a
            particular Service, termination of Your Account may include: (i)
            removal of access to all offerings within the Website o Account
            Information, including Your personal information, log-in ID and
            password, and all related information, files and materials ass
            barring of further use of the Services;
          </li>

          <li>
            Not with standing the foregoing, these Terms of Use will survive
            indefinitely unless and until Jac Pvt. Ltd. choo
          </li>

        </ul>
        <h1>15.&nbsp;&nbsp; Governing Law</h1>
        <ul>
          <li>
            These Terms of Use and all transactions entered into on or through
            the Website and the relationship between You and Jain auto corp. On laws of
            India without reference to conflict of laws principles;
          </li>
          <li>
            You agree that all claims, differences and disputes arising under or
            in connection with or in relation hereto the Website, the Terms or
            the relationship between You and Jac Pvt. Ltd. shall be subject to
            the exclusive jurisdiction of the courts at New D of such courts;
          </li>
        </ul>
        <h1>16.&nbsp;&nbsp; Report Abuse</h1>
        <p>
          In the event You come across any abuse or violation of these Terms of
          Use or if You become aware of any objectionable content on the
          customer support;
        </p>
        <p>&nbsp;</p>
        <h1>17.&nbsp;&nbsp; Privacy Policy</h1>
        <p>
          The User hereby consents, expresses and agrees that he has read and
          fully understands the Privacy Policy of Jac Pvt. and contents of such
          Privacy Policy are acceptable to You;
        </p>
        <p>&nbsp;</p>
        <h1>18.&nbsp;&nbsp; Communications</h1>
        <p>
          You hereby expressly agree to receive communications by way of SMS,
          E-Mails from Jac Pvt. Ltd./authorized third
        </p>
        <p>&nbsp;</p>
        <h1>19.&nbsp;&nbsp; General Provisions</h1>
        <ul>
          <li>
            Notice: All notices of Jac Pvt. Ltd. will be served by E-Mail or by
            general notification on the Website. Any noti Terms of Use should be
            sent to Jac Pvt. Ltd. customer support;
          </li>
          <li>
            Assignment: You cannot assign or otherwise transfer the Terms of
            Use, or any rights granted here under to any third Electric vehcile
            transferable by Jac Pvt. Ltd. to any third parties without the
            requirement of seeking Your consent;
          </li>
          <li>
            Severability: If, for any reason, a court of competent jurisdiction
            finds any provision of the Term of Use, or portion thereof, to be
            extent permissible so as to give effect to the intent of the parties
            as reflected by that provision, and the remainder of the Terms of
            Use s
          </li>
          <li>
            Waiver: Any failure by Jac Pvt. Ltd. to enforce or exercise any
            provision of the Terms of Use, or any related rig of that provision
            or right;
          </li>
        </ul>
        <p>&nbsp;</p>
        <h1>20.&nbsp; &nbsp;Feedback and Information</h1>
        <p>
          Any feedback You provide to this Website shall be deemed to be
          non-confidential. Jac Pvt. Ltd. shall be free to use s the feedback,
          You represent and warrant that (i) Your feedback does not contain
          confidential or proprietary information of You or of thi obligation of
          confidentiality, express or implied, with respect to the feedback;
          (iii) Jac Pvt. Ltd. may have something development; and (iv) You are
          not entitled to any compensation or reimbursement of any kind from Jac
          Pvt. Ltd. for
        </p>
        <p>&nbsp;</p>
        <h1>21.&nbsp;&nbsp; Return Policy</h1>
        <p>
          No returns/refunds accepted. Goods once sold will not be replaced or
          returned.Under any condition no refund will be made.
        </p>
        <p>All rights reserved.</p>
      </div>

    </div>
    <Footer />
    </>
  );
};

export default Tnc;
